export default __webpack_public_path__ + "static/media/m_engineering_card22_1.a52fdec1.png";